import { render, staticRenderFns } from "./LoyaltySettings.vue?vue&type=template&id=1873038b&scoped=true&"
import script from "./LoyaltySettings.vue?vue&type=script&lang=js&"
export * from "./LoyaltySettings.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltySettings.vue?vue&type=style&index=0&id=1873038b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873038b",
  null
  
)

export default component.exports